export default __webpack_public_path__ + "static/arrow_02_dark-edfc764eb5dc8d76b53fe1462ca52b87.png";